export default __webpack_public_path__ + "static/media/a8.a004b3fc.png";